import { AuthorizedContent, useEntitlements } from "@frontegg/react";
import { Role } from "../../constants/roles";
import { ReactNode, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { DraftOnly } from "@components/project/DraftModeRequired.component";
import { useFeatureFlagValue } from "@services/featureFlags/featureFlag.service";

interface Props {
    children?: ReactNode;
}

const TenantConfigSubnav = (props: Props) => {
    const location = useLocation();
    const hostedSupersetEnabled = useFeatureFlagValue('hosted-superset', false);
    const activePage = useMemo(() => {
        let path = location.pathname;

        if (path.endsWith('/')) {
            path = path.substring(0, path.length - 1);
        }
        
        if (path.endsWith('/build-schedule')) {
            return 'schedule';
        } else if (path.endsWith('/git-setup')) {
            return 'git';
        } else if (path.endsWith('/sources')) {
            return 'sources';
        } else if (path.endsWith('/billing')) {
            return 'billing';
        } else if (path.endsWith('/bi-setup')) {
            return 'superset';
        }else if (path.endsWith('/billing')) {
            return 'billing';
        }

        return 'schedule';
    }, [location]);


    return <nav className="subnav">
        <Link to={`/account/build-schedule`} className={`nav-link ${activePage == 'schedule' ? 'active' : ''}`}>
            <i className="mdi mdi-calendar-clock"></i> Build Schedule
        </Link>
        <AuthorizedContent requiredRoles={[Role.Admin]} key="tenant-admin-wrap" >
            <Link to={`/account/sources`} className={`nav-link ${activePage == 'sources' ? 'active' : ''}`}>
                <i className="mdi mdi-file-multiple"></i> Sources
            </Link>
        </AuthorizedContent>
        {/* <Link to={`/account/git-setup`} className={`nav-link ${activePage == 'git' ? 'active' : ''}`}>
            <i className="mdi mdi-git"></i> Git
        </Link> */}
        {/* <Link to={`/account/billing`} className={`nav-link ${activePage == 'billing' ? 'active' : ''}`}>
            <i className="mdi mdi-credit-card-multiple"></i> Billing
        </Link> */}
        {hostedSupersetEnabled &&
            <DraftOnly>
                <Link to={`/account/bi-setup`} className={`nav-link ${activePage == 'superset' ? 'active' : ''}`}>
                    <i className="mdi mdi-chart-line"></i> BI Setup
                </Link>
            </DraftOnly>
        }
        <AuthorizedContent requiredRoles={[Role.Admin]} key="tenant-billing-wrap" >
            <Link to={`/account/billing`} className={`nav-link ${activePage == 'billing' ? 'active' : ''}`}>
                <i className="mdi mdi-file-multiple"></i> Billing
            </Link>
        </AuthorizedContent>
        
        <div className="actions">
            {props.children}
        </div>
    </nav>
}

export default TenantConfigSubnav;